import { Email } from "@/Common/Api/Contacts/Dto/Email";
import { EmailContact } from "@/Common/Api/Contacts/Dto/EmailContact";
import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { RemoveButton } from "@/Common/Components/Buttons/RemoveButton";
import { CheckboxControl } from "@/Common/Components/Inputs/CheckboxControl";
import { SelectLookupControl } from "@/Common/Components/Inputs/SelectLookupControl";
import { TextboxMaskedControl } from "@/Common/Components/Inputs/TextboxMaskedControl";
import { ValidationHelper } from "@/Common/Helpers/ValidationHelper";

interface EmailContactProp {
    email: Email | EmailContact;
    onRemove: () => void;
    isEmailFieldFocused?: boolean;
    onContactTypeChange: (value: string) => void;
    onEmailChange: (unmaskedValue: string, maskedValue: string) => void;
    onDefaultNotificationChange: (checked: boolean) => void;
    onOkToContactChange: (checked: boolean) => void;
    labelColumnWidth?: string;
    containerStyles?: React.CSSProperties;
}

class EmailContactEdit extends BaseReactComponent<EmailContactProp> {
    private readonly validationHelper = new ValidationHelper();

    public render(): JSX.Element {
        // fetch email validation info
        const emailValidationRule = this.validationHelper.getEmailValidationRule();
        const emailMask = emailValidationRule?.EditMaskPattern ?? "";
        const emailValidationErrorMessage = emailValidationRule?.ValidationErrorMessageLookupId
            ? cacheStore.GetLocalizedValueByLookupId(emailValidationRule.ValidationErrorMessageLookupId)
            : "";

        const email = this.props.email;

        return (
            <div className="flex-container" style={{ justifyContent: "flex-start", ...this.props.containerStyles }}>
                <div style={{ flexGrow: 1 }}>
                    {this.renderRow(
                        "TypeLabel",
                        <SelectLookupControl
                            dataCy="emailContact-type"
                            style={{ height: "34px" }}
                            Value={email.ContactPointTypeLookupId}
                            AvailableValues={cacheStore.GetContactPointTypeLookups().map(lookUp => lookUp.ToComboboxItem())}
                            Callback={value => this.props.onContactTypeChange(value)}
                            Item={email}
                        />
                    )}
                    {this.renderRow(
                        "AddressLabel",
                        <TextboxMaskedControl
                            dataCy="emailContact-address"
                            isValid={EmailContact.validateEmail(email.Address)}
                            returnMaskedValue
                            id={`emailMasked_${this.props.email.renderId}`}
                            value={email.Address}
                            onChangeFunction={(unmaskedValue: string, maskedvalue: string) => this.props.onEmailChange(unmaskedValue, maskedvalue)}
                            mask={emailMask}
                            validationErrorMessage={emailValidationErrorMessage}
                            isEmail
                            focus={this.props.isEmailFieldFocused}
                        />
                    )}
                    {this.renderRow(
                        "",
                        <CheckboxControl
                            dataCy="emailContact-notifyPatient"
                            checked={email.NotificationsEnabled}
                            label={cacheStore.GetString("NotifyPatientLabel")}
                            onChange={checked => this.props.onDefaultNotificationChange(checked)}
                            item={email}
                        />
                    )}
                </div>
                <div style={{ width: "40px", flexGrow: 0 }}>
                    <div className="flex-container" style={{ justifyContent: "flex-start", height: "100%" }}>
                        <div style={{ borderLeft: "solid 1px #ccc" }} />
                        <div style={{ cursor: "pointer", paddingLeft: "10px", paddingRight: "10px" }}>
                            <RemoveButton onRemove={() => this.props.onRemove()} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    private renderRow(labelKey: string, element: React.ReactNode): React.ReactNode {
        return (
            <div className="flex-container" style={{ marginBottom: "5px" }}>
                <div style={{ width: this.props.labelColumnWidth ?? "170px", paddingRight: "10px", alignSelf: "center" }}>
                    <span className="float-right">{cacheStore.GetString(labelKey)}</span>
                </div>
                <div style={{ flexGrow: 1, paddingRight: "10px", paddingLeft: "10px" }}>{element}</div>
            </div>
        );
    }
}

export { EmailContactEdit };
